import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-haiwai",
  "use": "icon-haiwai-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-haiwai\"><path d=\"M19.192 8.026a.724.724 0 01-.998.227l-.716-.451v10.32a1 1 0 01-1 1H3.522a1 1 0 01-1-1V7.803l-.716.45a.723.723 0 11-.772-1.224L10 1.381l8.965 5.647a.724.724 0 01.227.998zM3.969 6.89v10.285a.5.5 0 00.5.5h11.062a.5.5 0 00.5-.5V6.89L10 3.092 3.969 6.89zm9.432 6.983v.447a.5.5 0 01-.5.5H7.137a.5.5 0 01-.5-.5v-.447a.5.5 0 01.5-.5h5.764a.5.5 0 01.5.5zm0-3.86v.448a.5.5 0 01-.5.5H7.137a.5.5 0 01-.5-.5v-.448a.5.5 0 01.5-.5h5.764a.5.5 0 01.5.5z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/haiwai.svg
// module id = 473
// module chunks = 4